<template>
  <b-container>
    <b-row class="mx-auto">
      <b-col cols="12">
        <label for="answer" class="mb-3 title-question-list" v-html="question.title" style="text-align: justify;padding-right: 0.9rem;"></label>
      </b-col>
      <b-col sm="12" md="8" lg="8" xl="8" class="mx-auto">
        <b-form-select v-model="selected" :options="valuesFormatted" @change="changeStep()">
          <option :value="null" disabled>Please select an option</option>
        </b-form-select>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      selected: null,
      valuesFormatted: [],
    };
  },
  watch: {
    // whenever question changes, this function will run
    question: function (newVal, oldVal) { // watch it
      this.formatList();
    }
  },
  mounted () {
    this.formatList();  
  },
  methods: {
    formatList () {
      this.valuesFormatted = [];
      this.selected = null;
      for (let index = 0; index < this.question.options.length; index++) {
        this.valuesFormatted.push({ 'value': this.question.options[index], 'text': this.question.options[index].title });
      }
    },
    changeStep () {
      this.question.value = this.selected.title;
      /* send object and with value, next Question id and previus, and set value in json reactive */ 
    
      this.$emit('change-step', {
        nextQuestionId: this.selected.next_question_id, 
        previusQuestionId: this.selected.previus_question_id
      });
    },
  }

};
</script>

<style lang="css">
.smiley {
  width: 100%;
  cursor: pointer;
}
.title-question-list {
    margin-bottom: 1rem;
    font-size: 20px;
    font-weight: bold;
  }
@media only screen and (orientation: portrait) and (max-width: 475px)  {
  .title-question-list {
    margin-bottom: 1rem;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>


// WEBPACK FOOTER //
// src/surveys/v2/components/List.vue